export default __webpack_public_path__ + "Darga_SWE_Resume.8EvVN.docx";